import classNames from 'classnames'
import { Howler } from 'howler'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'

import config from '@config'
import {
  DesktopStub,
  FeedbackProvider,
  Loader,
  LoaderProvider,
  useShouldShowDesktopStub,
} from '@ds'
import '@ds/styles/index.scss'
import { ChannelJoinDrawer, NewCardModal, useHowler } from '@shared'
import { LayoutTheme, useApp, useAppIsFollowedRefresh, useUser } from '@store'

import styles from './App.module.scss'
import routes from './Routes'
import { useAppResources } from './bootstrap/hooks/useAppResources'
import { AudioProvider } from './bootstrap/providers/AudioProvider'
import { OverlayRenderer } from './modules/shared/overlayRenderer'

const isAndroid = /Android/i.test(navigator.userAgent)

Howler.autoUnlock = true

const includeDebugger = () => {
  if (document.querySelector('#eruda')) return
  const script = document.createElement('script')

  script.onload = function () {
    if ((window as any).eruda) {
      try {
        ; (window as any).eruda.init()
      } catch { }
    }
  }
  script.src = 'https://cdn.jsdelivr.net/npm/eruda'
  script.id = 'eruda'

  document.head.appendChild(script)
}

if (config.showDebugger) {
  includeDebugger()
}

export const AVAILABLE_USERS_ID = [558161625, 527223923, 6716873498, 759764082, 849394687, 813969302, 264608327]

function App() {
  const layoutTheme = useApp.store.layoutTheme()
  const { resourcesLoaded } = useAppResources()
  const user = useUser.store.profile()
  const shouldShowDesktopStub = useShouldShowDesktopStub()

  const isFollowedRefresh = useAppIsFollowedRefresh()
  const { t, ready } = useTranslation()
  const { audio } = useHowler({
    src: '/sounds/Glance_soundtrack.mp3',
    loop: true,
    volume: 0.6,
    preload: true,
  })

  const handleClick = () => {
    if (!isFollowedRefresh || !isAndroid) {
      return
    }
    window.location.reload()
  }

  useEffect(() => {
    if (!audio) return

    audio.stop()
    audio.play()

    return () => {
      audio.stop()
    }
  }, [audio])

  if (!resourcesLoaded) {
    return (
      <Loader
        className={styles.loader}
        title={ready ? t('main.loader_app') : ''}
      />
    )
  }

  // if (!AVAILABLE_USERS_ID.includes(user?.id ?? 0)) {
  //   return (
  //     <div>
  //       <img src="/assets/app/prepare-release.png" alt="Cooking" />
  //     </div>
  //   )
  // }

  if (shouldShowDesktopStub && !config.isDev) {
    return <DesktopStub />
  }

  return (
    <LoaderProvider>
      <AudioProvider>
        <div
          onClick={handleClick}
          className={classNames(
            layoutTheme === LayoutTheme.UI ? styles.bgUi : styles.bgQuest
          )}
        >
          <BrowserRouter>
            <FeedbackProvider>{routes}</FeedbackProvider>
            <NewCardModal />
            <OverlayRenderer />
            <ChannelJoinDrawer />
          </BrowserRouter>
        </div>
      </AudioProvider>
    </LoaderProvider>
  )
}

export default App
